<template>
  <main>
    <div class="main">
      <dl class="titleTip">
        <dt>学术讲座</dt>
        <dd></dd>
      </dl>
      <div class="filter">
        <p @click.stop="sort = 0" :class="sort === 0 ? 'active' : ''">
          最新上传
        </p>
        <p @click.stop="sort = 1" :class="sort === 1 ? 'active' : ''">
          观看最多
        </p>
      </div>
      <div class="ulBox">
        <ul>
          <li
            @click="toVideoPage(item.videoId)"
            v-for="item in videoList"
            :key="item.videoId"
          >
            <img :src="item.img" />
            <div>
              <p class="title">{{ item.name }}</p>
              <p class="name" v-html="item.author"></p>
              <p class="organization" v-html="item.organization"></p>
              <p class="date">上传时间: {{ item.time }}</p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 分页器 -->
      <!--<Pager :countNumber.sync="countNumber"-->
      <!--:currentPage.sync="currentPage"-->
      <!--:pagesizeList.sync="pagesizeList"-->
      <!--:pagesize.sync="pagesize"-->
      <!--:showPagesize="false"-->
      <!--&gt;</Pager>-->
    </div>
  </main>
</template>
<script>
import Pager from "../../../components/Pager/Pager";

export default {
  name: "TeachingVideo",
  components: {
    Pager: Pager,
  },
  created() {
    this.getSpecialTopicList();
    this.getVideoListByLimit();
  },
  data() {
    return {
      videoList: [],
      specialTopicList: [],
      specialTopicId: "", // 专题ID
      sort: 0, // 0：最新 1：最热
      // 分页器
      countNumber: 0,
      currentPage: 1, // 当前页数
      pagesizeList: [12],
      pagesize: 12,
    };
  },
  methods: {
    changespecialTopic(specialTopicId) {
      this.specialTopicId =
        this.specialTopicId === specialTopicId ? "" : specialTopicId;
      this.getVideoListByLimit();
    },
    getSpecialTopicList() {
      this.$api.getSpecialTopicList().then((r) => {
        if (r.code === 1) {
          this.specialTopicList = r.data;
        }
      });
    },
    getVideoListByLimit() {
      const params = {
        sort: this.sort,
        specialTopicId: this.specialTopicId,
        currentPage: this.currentPage,
      };
      this.$api.getVideos().then((r) => {
        if (r.code === 1) {
          this.countNumber = r.data.length;
          this.videoList = r.data;
        } else {
          console.error(r.message);
        }
      });
    },
    toVideoPage(id) {
      this.$router.push({ path: "/teachingvideo/videos?videoId=" + id });
      // let newpage = this.$router.resolve({
      //     path: '/teachingvideo/videos?videoId='+id,
      // })
      // window.open(newpage.href, '_blank');
    },
  },
  watch: {
    sort() {
      this.getVideoListByLimit();
    },
    currentPage() {
      this.getVideoListByLimit();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./TeachingVideo.scss";
</style>
